import { Component, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ServiceProvider } from '../../core/service/service.provider';
import { LocalStorageService } from '../../shared/local-storage.service'
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    device_counts:any = null;
    interval_callback;
    isLoading = false;
    dashboard_for;
    role_change = false;
    show_dash_data = 'live_status'

  constructor(public dataService: ServiceProvider, private storage: LocalStorageService, private route: ActivatedRoute,
    private router: Router,) { }

  ngOnInit() {
      this.isLoading = true;
    this.getDashboardCounts()
    this.storage.isCheck("userData") && (this.dashboard_for = this.storage.getData("userData")['role_data']['role_for'])
    this.storage.watchStorage().subscribe((data:string) => {
        if(data == 'isRoleChange'){
            // this.storage.removeData(data)
            this.isLoading = true;
            this.liveStatusChart = null;
            this.customerPieChart = null;
            this.role_change = true;
            this.show_dash_data = 'live_status'
            this.dashboard_for = this.storage.getData("userData")['role_data']['role_for']
            this.device_counts && this.getDashboardCounts()
        }
    })

    // Get Auth Token for connect MAD API's 
    this.getMADAuthToken()

    this.interval_callback = setInterval(() => {
        this.getDashboardCounts(); 
      }, 5000);
  }

  getMADAuthToken(){
    this.dataService.post('AuthMADPlatform', null, {username: environment.madUserName, password: environment.madPassword}, true)
    .subscribe((values) => {
        localStorage.setItem("MADAccessToken", values.access_token)
        localStorage.setItem("MADAccessTokenPrefix", values.token_type)
    });
  }

  getDashboardCounts(){
    this.dataService.get('GetDashboardCounts')
    .subscribe((values) => {
        if(this.device_counts == null ){
            this.device_counts = values
            values.live_status.group.customer_based.length > 0 && this.inizializeLiveChart(values)
            this.dashboard_for == "MW Central" && values.inventory_data.group.customer_based.length && this.inizializeInventoryChart(values)
        }else{
            this.device_counts = values
            this.role_change && values.live_status.group.customer_based.length > 0 && this.inizializeLiveChart(values)
            this.role_change && this.dashboard_for == "MW Central" && values.inventory_data.group.customer_based.length && this.inizializeInventoryChart(values)
            this.role_change = false;
            // this.liveStatusChart.options.series.forEach(series_data => {
            //     series_data.data = values.live_status.group.customer_based.map(data=> data[series_data.name.toLowerCase()])
            // });
        }
        this.isLoading = false;
    });
  }
    
    pieChart;
    customerPieChart;
    liveStatusChart;
//////////////////////////////////

    goToDetailsPage(obj, key){
        this.storage.setData(key, obj)
        if(key == 'Live Data'){
            this.router.navigate(['monitoring'])
        }else{
            this.router.navigate(['inventory/devices'])
        }
    }

    inizializeLiveChart(value){
        let $this = this;

        this.liveStatusChart = new Chart({
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                scrollablePlotArea: {
                    // minHeight: 400,
                    scrollPositionX: 1
                }
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: value.live_status.group.customer_based.map(data=> data.name.toUpperCase()),
                // max: 4,
                scrollbar : {
                    enabled: true
                },
                labels: {
                    style: {
                        color: "#444",
                        fontWeight: 'bold'
                    },
                    overflow: 'justify'
                },
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function () {
                                let obj = {customer_name: this.category, live_status: this.series.name}
                                $this.goToDetailsPage(obj, "Live Data")
                            }
                        }
                    }
                }
            },
            yAxis: {
                tickInterval: 10,
                title: {
                    style: {
                        color: "#444",
                        fontWeight: 'bold'
                    },
                    text: 'LIVE STATUS'
                },
                lineWidth: 1,
                opposite: false
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Online',
                data: value.live_status.group.customer_based.map(data=> data.online),
                type: undefined,
                color: "#29b10c"
            }, {
                name: 'Offline',
                data: value.live_status.group.customer_based.map(data=> data.offline),
                type: undefined,
                color: "#c5474f"
            }]
        });
    }

    inizializeInventoryChart(value){
        let $this = this;
        let live_devcie = []
        value.inventory_data.group.customer_based.forEach(element => {
            live_devcie.push({
                name: element.name.toUpperCase(),
                y: element.live
            })
        });


        this.customerPieChart = new Chart({
            chart: {
                type: 'pie',
                // width: 700,
                backgroundColor: 'transparent',
            },
            title: {
                text: 'ONSITE - LIVE',
                style: {
                    color: "#444",
                    fontWeight: 'bold'
                },
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function () {
                                let obj = {customer_name: this.name, device_status: this.series.name}
                                $this.goToDetailsPage(obj, "Device Data")
                            }
                        }
                    }
                }
            },
            // plotOptions: {
            //     pie: {
            //         size: 250
            //     }
            // },
            series: [{
                type: 'pie',
                name: 'Onsite - Live',
                colors: ["#7cb5ec", "#338fe8", "#136dc3", "#044890", "#023571", "#54a0ea", "#6784a0", "#45a0f7", "#4586b5"],
                data: live_devcie
            }]
        });
    }

    online_download_loading = false;
    offline_download_loading = false;

    downloadCSVFile(type){
        this[type+'_download_loading'] = true;
        this.dataService.get('downloadCSVDevices', {device_type: type}, null, false, true)
            .subscribe((values) => {
                let myBlob = new Blob([values], {type: 'text/csv'});
                let downloadUrl = URL.createObjectURL(myBlob);
                let a = document.createElement('a');
                a.href = downloadUrl;
                a.download = type + '.csv';
                a.click();
                setTimeout( ()=> {
                    URL.revokeObjectURL(downloadUrl);
                    this[type+'_download_loading'] = false;
                }, 100);
            });
    }


    ngOnDestroy() {
        if (this.interval_callback) {
          clearInterval(this.interval_callback);
        }
      }

}
